import { action, payload } from "ts-action";
import {
  BranchSelectionMap,
  IScheduledServiceDisable,
  IServiceDisableMetadata,
  ServiceType,
} from "../../types/audit";

export const setServiceAuditBaseline = action(
  "SET_SERVICE_AUDIT_BASELINE",
  payload<BranchSelectionMap>()
);

export const setServiceDisableMetadata = action(
  "SET_SERVICE_DISABLE_METADATA",
  payload<{
    branchId: string;
    serviceType: ServiceType;
    metadata: IServiceDisableMetadata | null;
  }>()
);

export const setScheduledServiceDisable = action(
  "SET_SCHEDULED_SERVICE_DISABLE",
  payload<IScheduledServiceDisable | null>()
);

export const setAuditActor = action(
  "SET_AUDIT_ACTOR",
  payload<{ id?: string; name: string; email?: string; user_name?: string; actor_type?: string }>()
);

export const removeScheduledServiceDisable = action(
  "REMOVE_SCHEDULED_SERVICE_DISABLE",
  payload<{ branchId: string; serviceType: ServiceType }>()
);

export const setServiceEnableOverride = action(
  "SET_SERVICE_ENABLE_OVERRIDE",
  payload<{ branchId: string; serviceType: ServiceType }>()
);

export const commitServiceAuditState = action(
  "COMMIT_SERVICE_AUDIT_STATE",
  payload<BranchSelectionMap>()
);

export const clearServiceAuditState = action("CLEAR_SERVICE_AUDIT_STATE");

export const setAuditPrevMenuCategory = action(
  "SET_AUDIT_PREV_MENU_CATEGORY",
  payload<Record<string, any> | null>()
);

export const setAuditPrevMenuItem = action(
  "SET_AUDIT_PREV_MENU_ITEM",
  payload<Record<string, any> | null>()
);